import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as siteActions from '../../../actions/siteActions';
import * as systemActions from '../../../actions/systemActions';
import * as waterReadingActions from '../../../actions/waterReadingActions';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Container, Row, Col, Label, Collapse, Button } from 'reactstrap';
import systemsToSelectOptions from '../../../utils/systemSelectFormatter';
import sitesToSelectOptions from '../../../utils/siteSelectFormatter';
import WaterReading from './WaterReading';
import ChlorineChart from '../charts/ChlorineChart';
import MasterMeterChart from '../charts/MasterMeterChart';
import Select from 'react-select';
import WaterReadingForm from './WaterReadingForm';
import { toast } from 'react-toastify';
import * as REGEX from '../../../constants/regex';
import moment from 'moment';
import { loadUsers, loadLimitedUsers } from '../../../actions/userActions';
import { hasRole } from '../../../services/authService';

class WaterReadingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      systems: props.systems,
      sites: props.sites,
      selectedSystem: {},
      selectedSite: {},
      chlorineData: [],
      masterMeterData: [],
      waterReading: {
        siteId: '',
        timestamp: '',
        masterReading: '',
        freeChlorine: '',
        totalChlorine: '',
        chemicalReading: '',
        comments: '',
        userId: '',
      },
      errors: {},
      saving: false,
      collapse: window.innerWidth > 576,
      selectedSystemState: 'MO',
      waterReadings: props.waterReadings.sort(function (a, b) {
        return new Date(b.timestamp) - new Date(a.timestamp);
      }),
    };
  }

  componentWillMount() {
    this.props.actions.loadSystems();
    this.props.actions.loadSites();
    this.props.actions.loadLimitedUsers();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.waterReadings) {
      if (this.props.waterReadings !== nextProps.waterReadings) {
        this.setState({
          waterReadings: nextProps.waterReadings.sort(function (a, b) {
            return new Date(b.timestamp) - new Date(a.timestamp);
          }),
        });
      }
    }
  }

  updateReadingState = (event) => {
    const field = event.target.id;
    let reading = Object.assign({}, this.state.waterReading);
    reading[field] = event.target.value;
    this.setState({ waterReading: reading });
  };

  handleSystemChange = (selectedOption) => {
    if (selectedOption !== null) {
      const sitesForSystem = this.props.sites.filter(
        (site) => site.systemId === selectedOption.value
      );
      const system = this.props.systems.filter(
        (system) => system.id === selectedOption.value
      );
      this.setState({ selectedSite: {} });
      const siteOptions = sitesToSelectOptions(sitesForSystem);
      this.setState({
        sites: siteOptions,
        selectedSystem: selectedOption,
        selectedSystemSite: system[0].systemState,
      });
    }
  };

  handleSiteChange = (selectedOption) => {
    this.setState({ selectedSite: selectedOption }, () => {
      this.loadWaterReadings();
    });
  };

  loadWaterReadings = () => {
    const { selectedSite } = this.state;
    if (typeof selectedSite !== 'undefined')
      this.props.actions.loadWaterReadings(selectedSite.value);
  };

  formIsValid() {
    const { waterReading } = this.state;
    let errors = {};
    let isValid = true;

    if (waterReading.freeChlorine === '') {
      errors.freeChlorine = 'Enter the free chlorine amount.';
      isValid = false;
    } else if (!REGEX.DECIMAL_2_PLACES.test(waterReading.freeChlorine)) {
      errors.freeChlorine = 'Please enter a decimal number.';
      isValid = false;
    } else if (
      Number(waterReading.freeChlorine) < 0 ||
      Number(waterReading.freeChlorine) > 3.5
    ) {
      errors.freeChlorine321 = 'Please enter a value between 0.00 and 3.50';
      isValid = false;
    }
    if (waterReading.totalChlorine !== '') {
      if (!REGEX.DECIMAL_2_PLACES.test(waterReading.totalChlorine)) {
        errors.totalChlorine = 'Please enter a decimal number.';
        isValid = false;
      } else if (
        Number(waterReading.totalChlorine) < 0 ||
        Number(waterReading.totalChlorine) > 3.5
      ) {
        errors.totalChlorine = 'Please enter a value between 0.00 and 3.50';
        isValid = false;
      }
    }
    if (waterReading.chemicalReading !== '') {
      if (Number(waterReading.chemicalReading) < 0) {
        errors.chemicalReading = 'Please enter a value greater than zero';
        isValid = false;
      }
    }
    this.setState({ errors: errors });
    return isValid;
  }

  clearForm() {
    this.setState({
      waterReading: {
        siteId: '',
        timestamp: '',
        masterReading: '',
        freeChlorine: '',
        totalChlorine: '',
        chemicalReading: '',
        comments: '',
        userId: '',
      },
    });
  }

  saveReading = (event) => {
    event.preventDefault();
    if (!this.formIsValid()) return;
    let waterReading = this.state.waterReading;
    waterReading.siteId = this.state.selectedSite.value;
    waterReading.timestamp = moment().format('YYYY-MM-DDTHH:mm:ss');
    waterReading.masterReading =
      waterReading.masterReading === '' ? null : waterReading.masterReading;
    waterReading.freeChlorine = waterReading.freeChlorine;
    waterReading.totalChlorine = waterReading.totalChlorine || null;
    waterReading.chemicalReading = waterReading.chemicalReading || null;
    waterReading.comments = waterReading.comments || null;
    waterReading.userId = this.props.currentUser.id;
    this.setState({ saving: true });
    this.props.actions
      .saveWaterReading(waterReading)
      .then(() => {
        toast.success('Reading saved.');
        this.clearForm();
        this.setState({ saving: false });
      })
      .catch((error) => {
        toast.error(error.message);
        this.setState({ saving: false });
      });
  };

  toggleCharts = () => {
    this.setState({
      collapse: !this.state.collapse,
    });
  };

  render() {
    const { selectedSystem, selectedSite, waterReadings, collapse, sites } =
      this.state;
    const { users, systemOptions } = this.props;
    return (
      <div>
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <h1 className="text-center my-4">Water Readings</h1>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Label for="systemSelect" className="mr-2">
                System
              </Label>
              <Select
                name="systemSelect"
                value={selectedSystem}
                onChange={this.handleSystemChange}
                options={systemOptions}
              />
            </Col>
            <Col md={6}>
              <Label for="siteSelect" className="mr-2">
                Site
              </Label>
              <Select
                name="siteSelect"
                value={selectedSite}
                onChange={this.handleSiteChange}
                options={sites}
              />
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <hr className="m4-4" />
            </Col>
          </Row>

          <Row>
            <Col md={12} className="text-right">
              <Button
                color="primary"
                className="mb-2"
                onClick={this.toggleCharts}
              >
                {collapse ? 'Hide Charts' : 'Show Charts'}
              </Button>
            </Col>

            <Col md={6}>
              <Collapse isOpen={collapse}>
                <h5 className="text-center">Chlorine</h5>
                <ChlorineChart data={waterReadings} />
              </Collapse>
            </Col>

            <Col md={6}>
              <Collapse isOpen={collapse}>
                <h5 className="text-center">Water Usage</h5>
                <MasterMeterChart data={waterReadings} />
              </Collapse>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <hr className="my-4" />
            </Col>
          </Row>
          <WaterReadingForm
            reading={this.state.waterReading}
            saving={this.state.saving}
            onChange={this.updateReadingState}
            onSave={this.saveReading}
            errors={this.state.errors}
            systemState={this.state.selectedSystemSite}
          />
          <Row>
            <Col md={12}>
              <hr className="my-4" />
            </Col>
          </Row>
          <Row>
            {waterReadings.length > 0 ? (
              waterReadings.map((reading) => (
                <WaterReading
                  key={reading.id}
                  reading={{ ...reading }}
                  user={users.filter((u) => u.id === reading.userId)[0]}
                  isManager={hasRole('ROLE_MANAGER')}
                />
              ))
            ) : (
              <Col md={12}>
                <h4 className="my-4">No readings found</h4>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    );
  }
}

WaterReadingPage.propTypes = {
  waterReadings: PropTypes.array,
  actions: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
};

function mapStateToProps(state) {
  const filtered = state.systems.filter((s) => s.systemType === 'Water' && s.isActive);
  const systemOptions = systemsToSelectOptions(filtered);

  return {
    systems: state.systems,
    systemOptions: systemOptions,
    sites: state.sites,
    waterReadings: state.waterReadings,
    currentUser: state.currentUser,
    users: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...siteActions,
        ...systemActions,
        ...waterReadingActions,
        loadUsers,
        loadLimitedUsers,
      },
      dispatch
    ),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WaterReadingPage)
);



// WEBPACK FOOTER //
// ./src/components/reading/water/WaterReadingPage.js